<script lang="ts">
  import Button from "$lib/components/Button/Button.svelte"
  import { Input } from "$lib/components/ui/input"
  import userStore, { userStoreActions } from "$lib/stores/userStore"

  interface Props {
    action: any
    competition: any
    processAction: (action: any) => void
    isPreview?: boolean
  }

  let {
    action,
    competition,
    processAction,
    isPreview = false,
  }: Props = $props()

  let errorMessage = ""

  function openUrl(action) {
    const url = action.requirements.find((r) => r.name === "Url")?.value
    window.open(
      `${url}?utm_source=${window.location.host}${window.location.pathname}`,
      "_blank",
    )
  }

  let description = $derived(
    (action.selectedAction || action)?.requirements.find(
      (r) => r.name === "Description",
    )?.value,
  )

  let callToAction = $derived(
    (action.selectedAction || action)?.requirements.find(
      (r) => r.name === "CallToAction",
    )?.value,
  )
</script>

{#if isPreview}
  <div class="p-4">
    <div>
      {#if description}
        <div class="text-black">
          {@html description}
        </div>
      {:else}
        <p class="text-base font-semibold">Instructions:</p>
        <ol class="list-disc list-inside mt-2 text-sm leading-6">
          <li>Enter another giveaway to earn more entries</li>
          <li>Click the button below to find more giveaways</li>
        </ol>
        <p class="text-sm leading-6 my-2">
          Once you've entered another giveaway, your bonus entries will be added
          instantly!
        </p>
      {/if}
    </div>

    <div class="mt-2 flex items-center space-x-2 max-w-md">
      <Button
        class="w-full bg-black text-white hover:bg-gray-800"
        onclick={() => {}}
      >
        {callToAction || "Enter Another Giveaway"}
        <span class="ml-1">&#8599;</span>
      </Button>
    </div>
  </div>
{:else}
  <div class="p-4">
    <div class="space-y-4 max-w-[400px]">
      {#if description}
        <div class="text-[15px] text-black">
          {@html description}
        </div>
      {:else}
        <p class="text-base font-semibold">Instructions:</p>
        <ol class="list-disc list-inside mt-2 text-sm leading-6">
          <li>Enter another giveaway to earn more entries</li>
          <li>Click the button below to find more giveaways</li>
        </ol>
        <p class="text-sm leading-6 my-2">
          Once you've entered another giveaway, your bonus entries will be added
          instantly!
        </p>
      {/if}
    </div>

    <div class="flex flex-col space-y-2 max-w-md">
      {#if errorMessage}
        <p class="text-sm text-red-500">{errorMessage}</p>
      {/if}

      <div class="flex items-center space-x-2">
        <Button
          class="w-full bg-black text-white hover:bg-gray-800"
          onclick={() => {
            openUrl(action)
            processAction(action)
          }}
        >
          {callToAction || "Enter Another Giveaway"}
          <span class="ml-1">&#8599;</span>
        </Button>
      </div>
    </div>
  </div>
{/if}
